import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconShare = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M17.6989 14.6756C16.4826 14.6756 15.4324 15.3611 14.9016 16.3673L10.0698 13.57C10.2356 13.1829 10.3242 12.7628 10.3242 12.3205C10.3242 12.0662 10.291 11.812 10.2358 11.5687L15.5761 8.49498C16.1401 9.00354 16.8808 9.32422 17.6991 9.32422C19.446 9.32422 20.8612 7.90898 20.8612 6.16211C20.8612 4.41525 19.4571 3 17.6991 3C15.9522 3 14.537 4.41525 14.537 6.16211C14.537 6.47169 14.5813 6.75921 14.6585 7.03562L9.38453 10.076C8.80962 9.5121 8.02453 9.15841 7.16211 9.15841C5.41525 9.15841 4 10.5737 4 12.3205C4 14.0674 5.40415 15.4826 7.16211 15.4826C7.83648 15.4826 8.44468 15.2725 8.95324 14.9298L14.5479 18.1584C14.7137 19.7506 16.0515 21 17.688 21C19.4348 21 20.8501 19.5848 20.8501 17.8379C20.8502 16.0909 19.4682 14.6756 17.6991 14.6756H17.6989ZM17.6989 4.72467C18.495 4.72467 19.1362 5.36588 19.1362 6.16195C19.1362 6.95803 18.495 7.59923 17.6989 7.59923C16.9028 7.59923 16.2616 6.95803 16.2616 6.16195C16.2616 5.36588 16.925 4.72467 17.6989 4.72467ZM5.73564 12.3316C5.73564 11.5355 6.37685 10.8943 7.17292 10.8943C7.969 10.8943 8.6102 11.5355 8.6102 12.3316C8.6102 13.1277 7.969 13.7689 7.17292 13.7689C6.377 13.7689 5.73564 13.1166 5.73564 12.3316ZM17.6989 19.2752C16.9028 19.2752 16.2616 18.634 16.2616 17.8379V17.8047C16.2727 17.7495 16.2727 17.6941 16.2727 17.6499C16.3722 16.9422 16.9804 16.4116 17.688 16.4116C18.484 16.4116 19.1252 17.0528 19.1252 17.8488C19.1252 18.6449 18.495 19.2752 17.6989 19.2752L17.6989 19.2752Z" />
      </svg>
    );
  }
);
